export default defineNuxtPlugin(() => {
    const xsrfToken = useState<string>("xsrfToken");
    const locale = useNuxtApp().$i18n.locale;

    const api = $fetch.create({
        baseURL: "/api/",
        onRequest({ options }) {
            if (import.meta.server) {
                // Forward the original client's headers on server-to-server calls so the
                // backend resolves geo-IP (region/currency) against the real client IP
                // instead of the SSR server. useApi forwards a broader set (including the
                // DataDome headers); here we forward only what identity/info needs. The load
                // balancer still appends the SSR server IP to X-Forwarded-For; the backend
                // reads the original (first) IP.
                const headers = useRequestHeaders(["cookie", "x-forwarded-for", "user-agent"]);
                for (const [key, value] of Object.entries(headers)) {
                    if (value) options.headers.set(key, value);
                }
            }
            if (xsrfToken.value) options.headers.set("CSRF-Token", xsrfToken.value);
            options.query = { lang: locale.value, ...options.query };
        },
    });

    // Expose to useNuxtApp().$api
    return { provide: { api } };
});
